import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgChestGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.384 15.284c0 1.191 1.297 2.766 3.66 4.447a2.747 2.747 0 0 1 1.152 2.516 2.74 2.74 0 0 1-1.604 2.267c-.624.288-1.325.538-2.065.797-1.133.403-2.41.864-3.63 1.537C12.34 27.701 9.66 30.035 9.2 36L8 35.904c.509-6.521 3.544-9.133 5.31-10.113 1.255-.692 2.536-1.153 3.673-1.563l.14-.05c.72-.25 1.393-.5 1.97-.759.518-.24.854-.72.912-1.287a1.544 1.544 0 0 0-.653-1.421c-2.151-1.527-3.467-2.968-3.947-4.312a2.241 2.241 0 0 1-1.623-2.152A2.25 2.25 0 0 1 16.029 12v1.2a1.05 1.05 0 0 0-1.047 1.047c0 .557.442 1.009.99 1.037h.412Zm14.492 8.894c1.172.413 2.507.893 3.813 1.613 1.758.98 4.802 3.592 5.311 10.113L38.8 36c-.471-5.954-3.14-8.288-4.697-9.152-1.204-.674-2.464-1.122-3.586-1.521l-.044-.016c-.74-.26-1.44-.51-2.065-.797a2.76 2.76 0 0 1-1.604-2.267 2.728 2.728 0 0 1 1.153-2.516c2.362-1.671 3.659-3.256 3.659-4.447h.067c.547-.028.99-.48.99-1.037a1.05 1.05 0 0 0-1.048-1.046V12a2.25 2.25 0 0 1 2.248 2.247c0 .865-.5 1.614-1.22 1.988-.432 1.383-1.767 2.881-4.005 4.476-.46.326-.71.854-.653 1.421.058.567.394 1.047.913 1.287.576.26 1.258.509 1.968.759Z",
    fill: "currentColor"
  }));
}

export { SvgChestGlyph as default };
